import { AlertTriangle } from 'lucide-react';
import type { ReactNode } from 'react';
import { FigureMotif } from '@/components/brand/FigureMotif';
import { Button } from '@/components/ui/button';
import { AppError } from '@/lib/api/errors';

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const message =
    error instanceof AppError ? error.message : 'Something went wrong. Please try again.';
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-[var(--radius-card)] border border-red-500/20 bg-red-50/50 p-8 text-center dark:border-red-500/25 dark:bg-red-500/10">
      <AlertTriangle className="h-8 w-8 text-red-500" aria-hidden />
      <p className="text-sm text-red-700 dark:text-red-300">{message}</p>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  );
}

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-[var(--radius-card)] border border-line bg-surface-2/50 p-10 text-center">
      <FigureMotif className="h-16 w-16 opacity-60" />
      <h3 className="text-lg font-bold text-ink">{title}</h3>
      {description && <p className="max-w-md text-sm text-muted">{description}</p>}
      {action}
    </div>
  );
}
